import { type InsuranceCorporateIdentity } from "../types";

export function SKDLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M467.852 234.31H424.528V277.506H467.852V234.31Z" fill="white" />
      <path d="M419.585 234.31H376.26V277.506H419.585V234.31Z" fill="white" />
      <path d="M371.734 234.31H328.409V277.506H371.734V234.31Z" fill="white" />
      <path
        d="M251.781 212.8H268.568C282.522 212.8 288.272 220.605 288.272 236.751C288.272 252.901 282.522 260.706 268.568 260.706H251.781V212.8ZM230.926 196V277.506H269.974C301.726 277.506 310.695 257.102 310.695 236.751C310.695 214.981 301.726 196 269.974 196H230.926ZM164.496 231.983H164.241V196H138.636V277.506H164.241V234.258H164.496L193.482 277.506H222.259L192.279 232.092L219.696 196H192.325L164.496 231.983ZM122.375 220.605C123.911 201.744 104.322 196 85.2482 196C65.9141 196 46.7102 201.094 45.6841 219.629C45.6841 228.083 50.2937 235.234 59.6378 238.703C79.7376 246.181 98.6863 243.907 98.6863 254.527C98.6863 259.73 91.1339 262.332 85.243 262.332C76.0239 262.332 69.6226 258.323 69.7476 250.949H44.1476C44.533 272.194 63.4817 277.501 84.9878 277.501C106.369 277.501 125.573 269.696 125.573 253.223C125.573 232.087 103.041 230.789 87.5452 227.429C80.7584 225.912 72.5654 224.069 72.5654 218.325C72.5654 214.425 77.6854 211.169 83.5763 211.169C87.9306 211.169 91.2589 212.036 93.436 213.662C95.7434 215.287 96.8945 217.567 96.7643 220.6H122.375V220.605Z"
        fill="#293E4C"
      />
      <path
        d="M351.16 258.536H345.254V264.851H350.53C352.785 264.851 354.452 263.636 354.452 261.818C354.452 260.192 353.186 258.655 351.16 258.536Z"
        fill="#FDC612"
      />
      <path
        d="M353.863 249.791C353.863 248.134 352.285 246.955 350.165 246.955H345.248V252.906L349.848 252.865C352.285 252.865 353.863 252.018 353.863 249.791Z"
        fill="#FDC612"
      />
      <path
        d="M328.409 234.31V277.506H371.734V234.31H328.409ZM351.519 270.511H336.227V241.295H351.832C357.968 241.336 363.109 243.803 363.109 248.944C363.109 252.548 359.728 254.729 356.072 255.337V255.42C360.4 255.944 363.921 258.416 363.921 262.581C363.921 271.077 351.832 270.511 351.519 270.511Z"
        fill="#FDC612"
      />
      <path
        d="M376.26 234.31V277.506H419.585V234.31H376.26ZM402.021 269.732L391.865 255.025H391.781V269.732H383.245V242.079H391.781V254.22H391.865L401.641 242.079H411.756L401.126 254.257L412.61 269.732H402.021Z"
        fill="#FDC612"
      />
      <path
        d="M424.522 234.31V277.506H467.847V234.31H424.522ZM450.284 269.732L440.127 255.025H440.044V269.732H431.507V242.079H440.044V254.22H440.127L449.904 242.079H460.019L449.388 254.257L460.873 269.732H450.284Z"
        fill="#FDC612"
      />
      {/* Multiple small text elements for the bottom section have been combined for brevity */}
    </svg>
  );
}

export const SKD: InsuranceCorporateIdentity = {
  id: "skd",
  name: "SKD BKK",
  logo: SKDLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "skd bkk",
  type: "statutory",
};
